/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Skills_Marker_TooltipInputs */



/**
* | output |
* | --- |
* | "Comes with skills: the assistant can act through this integration directly in chat." |
*
* @param {Integrations_Skills_Marker_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_skills_marker_tooltip = /** @type {((inputs?: Integrations_Skills_Marker_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Skills_Marker_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bringt Skills mit: Der Assistent kann über diese Integration direkt im Chat handeln.")
	return /** @type {LocalizedString} */ ("Comes with skills: the assistant can act through this integration directly in chat.")
});